import React, { useEffect } from 'react';

import { userActions } from '../../actions';

import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';

function Reservation() {
  const dispatch = useDispatch();

  const reservationsState = useSelector(state => state.reservations);

  useEffect(() => {
    if (!reservationsState.items) {
      dispatch(userActions.getReservations());
    }
    dispatch(userActions.editReservation(null));
  }, [dispatch, reservationsState.items]);

  const confirmDelete = id => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Êtes-vous sûr?</h1>
            <p>Vous souhaitez annuler cette réservation?</p>
            <button onClick={onClose}>Non</button>
            <button
              className="invert"
              onClick={() => {
                dispatch(userActions.deleteReservation(id));
                onClose();
              }}
            >Oui</button>
          </div>
        );
      }
    });
  };

  return (
    <div className="bloc-reservation">
      <h2 className="bloc-reservation__title">
        <span className="bloc-reservation__icon">
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-15-raquette" />
          </svg>
        </span>
          Mes réservations
        </h2>
      <Link to="/reservation/planning" className="bloc-reservation__add">
        <svg className="icon" aria-hidden="true">
          <use xlinkHref="#icon-14-plus" />
        </svg>
        Ajouter une réservation
      </Link>

      {reservationsState.items && reservationsState.items.length === 0 &&
        <div className="bloc-reservation__no-item">
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-15-raquette" />
          </svg>
          <p><strong>Aucune réservation</strong><br />à venir pour le moment !</p>
        </div>
      }
      {reservationsState.items &&
        <ul className="bloc-reservation__list">
          {reservationsState.items.map((reservation) => {
            return (
              <li className="bloc-reservation__item" key={reservation.id}>
                <div>
                  <strong>{reservation.momentDebut.format('dddd DD MMMM')} </strong>
                  <span className="bloc-reservation__date">
                    de <strong>{reservation.momentDebut.format('LT')} à {reservation.momentFin.format('LT')}</strong>
                  </span>
                  <span className="bloc-reservation__people">avec {reservation.people}</span>
                </div>
                <div className="bloc-reservation__btn-group">
                  {reservation.canEdit &&
                    <Link to={`/reservation/${reservation.id}`} className="bloc-reservation__action">
                      <svg className="icon icon-edit" aria-hidden="true">
                        <use xlinkHref="#icon-10-edit" />
                      </svg>
                      Modifier
                    </Link>
                  }
                  {reservation.canCancel &&
                    <button className="bloc-reservation__action" onClick={() => confirmDelete(reservation.id)}>
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-08-delete" />
                      </svg>
                      Annuler
                    </button>
                  }
                </div>
              </li>
            );
          }
          )}
        </ul>
      }
    </div>
  );
}

export default Reservation;
